import Meet from 'containers/Appointments/Meet';
import { useEffect } from 'react';
import useAppointment from 'containers/Appointments/useAppointment';
import { useParams, useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { joinRoom } from 'containers/Room/actions/JoinRoom.actions';
import { useDispatch } from 'react-redux';
import TrackerCall from 'utils/TrackingCall';
import {
  setInCall,
  setNotInCall,
} from 'containers/WaitingRoom/actions/GetWaitingRoom.actions';
import { getRoom } from 'containers/Inbox/actions/GetRoomList.actions';
import {
  MedicalReportActionEnum,
  updateAutomaticReport,
} from 'state/medicalReports/index.slice';
import Call from 'containers/Appointments/Call';
import { setCurrentAppointment } from 'state/appointments.slice';
import { useGetAppointmentQuery } from 'services/appointments';
import { AppointmentChannelEnum } from 'models/appointment-channel.model';
import { AppointmentStatusEnum } from 'models/appointment-status.models';
import { useJoinQuery } from 'services/calls';

const Channel = ({ channel, ...props }: any) => {
  if (channel === 'videocall') {
    return <Meet {...props} />;
  }
  return <Call {...props} />;
};

const AppointmentMeet = () => {
  const dispatch = useDispatch();
  const { reporting, status, setStatus, inCall } = useAppointment();
  const { appointmentId } = useParams<{ appointmentId: string }>();
  const history = useHistory();

  const appointmentQuery = useGetAppointmentQuery({ appointmentId });
  const joinCallQuery = useJoinQuery(
    { callId: appointmentQuery.data?.call_id ?? '' },
    { skip: !appointmentQuery.data?.call_id }
  );

  const onFinish = () => {
    if (appointmentQuery.data?.channel === AppointmentChannelEnum.videocall) {
      TrackerCall.event('leave call');
      dispatch(updateAutomaticReport(MedicalReportActionEnum.Loading));
    }

    if (appointmentQuery.data) {
      reporting({ appointmentId: appointmentQuery.data.id });
    }
  };

  useEffect(
    function syncReduxStateOnAppointmentChange() {
      if (appointmentQuery.isSuccess) {
        dispatch(setInCall());
        dispatch(setCurrentAppointment(appointmentQuery.data));
        dispatch(getRoom({ roomId: appointmentQuery.data.room_id }));
        dispatch(joinRoom(appointmentQuery.data.room_id));
      }

      return () => {
        dispatch(setCurrentAppointment(null));
      };
    },
    [appointmentQuery]
  );

  useEffect(
    function syncTrackerCallOnAppointmentChange() {
      if (appointmentQuery.isSuccess) {
        TrackerCall.setConsultation({
          consultationId: appointmentQuery.data.id,
          consultationType: 'appointment',
          callId: appointmentQuery.data.call_id,
          userHash: appointmentQuery.data.from.hash,
          contactId: appointmentQuery.data.to.id,
        });
      }
    },
    [appointmentQuery]
  );

  useEffect(
    function syncInCallOnAppointmentChange() {
      if (appointmentQuery.isSuccess && joinCallQuery.isSuccess) {
        inCall({ appointmentId });
      }
    },
    [appointmentQuery.isSuccess, joinCallQuery.isSuccess]
  );

  if (!appointmentQuery.isSuccess || joinCallQuery.isLoading) {
    return null;
  }

  if (appointmentQuery.data.status === AppointmentStatusEnum.finished) {
    // todo Automate
    return (
      <Link to={'/waiting-room'} className="text-primary">
        Cita finalizada, volver a la Sala de espera
      </Link>
    );
  }

  return (
    <Channel
      channel={appointmentQuery.data?.channel}
      patient={appointmentQuery.data?.to}
      session={{
        id: joinCallQuery.data?.session_id,
        token: joinCallQuery.data?.session_token,
      }}
      roomId={appointmentQuery.data?.room_id}
      consultationType="appointment"
      consultationId={appointmentQuery.data?.id}
      onFinish={onFinish}
      onSkip={() => {
        console.log('skip is not allowed here');
      }}
      appointment={appointmentQuery.data}
      isImmediateVideoCall={
        appointmentQuery.data?.is_immediate_video_call ?? false
      }
      onExit={() => {
        dispatch(setNotInCall());
        dispatch(updateAutomaticReport(MedicalReportActionEnum.Reset));
        history.push('/appointments');
      }}
      status={status}
      setStatus={setStatus}
    />
  );
};

export default AppointmentMeet;
